import { BaseIcon } from "@dgs/core";
import { FC, ReactNode } from "react";
import styled from "styled-components";
import { Strong } from "./Card";

interface LegDestinationProps {
	name?: string;
	time: string;
	alignment: "left" | "right";
}

const LegDestinationContainer = styled.p<{ $alignment: string }>`
	text-align: ${({ $alignment }) => $alignment};
`;

export const LegDestination: FC<LegDestinationProps> = ({ name, time, alignment }) => {
	return (
		<LegDestinationContainer $alignment={alignment}>
			<Strong>{time}</Strong>
			<br />
			{name}
		</LegDestinationContainer>
	);
};

const LineWithIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	margin: 0 ${({ theme }) => theme.spacing(5)};
	color: ${({ theme }) => theme.colors.palette.grey[30]};

	> ${BaseIcon} {
		width: 24px;
		height: 24px;
	}

	&:before {
		top: 50%;
		left: 0;
		height: 1px;
		width: calc(50% - 24px);
		content: "";
		position: absolute;
		background: currentColor;
	}

	&:after {
		top: 50%;
		right: 0;
		height: 1px;
		width: calc(50% - 24px);
		content: "";
		position: absolute;
		background: currentColor;
	}
`;

const Container = styled.div`
	display: grid;
	grid-template-columns: minmax(min-content, 140px) 1fr minmax(min-content, 140px);
`;

interface Props {
	arrival: ReactNode;
	departure: ReactNode;
	iconSrc: string;
}

export const Leg: FC<Props> = ({ arrival, departure, iconSrc }) => {
	return (
		<Container>
			<div>{departure}</div>
			<LineWithIcon>
				<BaseIcon src={iconSrc} />
			</LineWithIcon>
			<div>{arrival}</div>
		</Container>
	);
};
